import React from "react";
import {  useLocation, useNavigate } from "react-router-dom";
import { Card, Row, Col, Button } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
const Co_host_Detail = () => {
  const navigate = useNavigate()
    const events = [
    {
      id: 1,
      name: "Sangeet Night",
      date: "12 Dec 2025",
      startTime: "7:00 PM",
      venue: "Grand Palace, Lucknow",
      theme: "Bollywood Night",
      dressCode: "Traditional",
      dressColor: "Golden & Red",
    },
    {
      id: 2,
      name: "Wedding Ceremony",
      date: "15 Dec 2025",
      startTime: "11:00 AM",
      venue: "Royal Heritage Resort",
      theme: "Classic Indian",
      dressCode: "Sherwani / Lehenga",
      dressColor: "Maroon & Cream",
    },
  ];

     const location = useLocation();
      const historyData = location.state?.history;
  return (
   <div >
       <PageTitle
          motherMenu="User List"
          activeMenu={`   ${historyData?.user?.hostName} > Co-Hosts > Events`}
          pathBack={true}   
        />
      {/* -------- Events Card -------- */}
  
      <Card className="shadow-lg event-card mb-5">
        <Card.Body>
          {events.map((event) => (
      
       <div key={event.id} className="event-item mb-4 p-3 rounded d-flex justify-content-between align-items-center">
  
  {/* Left side - Event details */}
 <div>
  <h5 className="fw-bold mb-3">{event.name}</h5>

  <div className="d-flex justify-content-between mb-1">
    <strong className="label-text me-5">Date:</strong>
    <span>{event.date}</span>
  </div>

  <div className="d-flex justify-content-between mb-1">
    <strong className="label-text">Start Time:</strong>
    <span>{event.startTime}</span>
  </div>

  <div className="d-flex justify-content-between mb-1">
    <strong className="label-text me-5">Venue:</strong>
    <span>{event.venue}</span>
  </div>

  <div className="d-flex justify-content-between mb-1">
    <strong className="label-text">Theme:</strong>
    <span>{event.theme}</span>
  </div>

  <div className="d-flex justify-content-between mb-1">
    <strong className="label-text">Dress Code:</strong>
    <span>{event.dressCode}</span>
  </div>

  <div className="d-flex justify-content-between mb-1">
    <strong className="label-text">Dress Color:</strong>
    <span>{event.dressColor}</span>
  </div>
</div>


  {/* Right side - Buttons */}
  <div className="ms-3">
    <Button
      className="me-2 maroon-btn"
      onClick={() => navigate(`/sub-events`)}
    >
      Sub Events
    </Button>
    <Button
      className="maroon-btn"
      onClick={() => navigate(`/tasks`)}
    >
      Tasks
    </Button>
  </div>
</div>

          ))}
        </Card.Body>
      </Card>


         </div>
  )
}

export default Co_host_Detail
